import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  IconButton,
  Typography,
  TextField,
  Select,
  MenuItem,
  Modal
} from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import LandscapeIcon from "@mui/icons-material/Landscape";
import { getData, postData } from "../../../ServerRequest";

export default function EditTagModal({ open, onClose, tagData, onSave }) {
  const [familyData, setFamilyData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [productTag, setProductTag] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [status, setStatus] = useState(1);
  const [tagImage, setTagImage] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        let familyRes = await getData("/api/product/acc_tag_family");
        let family_data = familyRes["data"]["tag_families"];
        if (family_data) setFamilyData(family_data);
        let categoryRes = await getData("/api/product/acc_tag_category");
        let category_data = categoryRes["data"]["tag_categories"];
        if (category_data) setCategoryData(category_data);
      } catch (error) {
        // handle error
      }
    }
    if (open) fetchData();
  }, [open]);

  useEffect(() => {
    if (tagData) {
      setProductTag(tagData.product_tag || "");
      setSelectedFamily(tagData.tag_family || "");
      setSelectedCategory(tagData.tag_category || "");
      setCreatedBy(tagData.created_by || "");
      setUpdatedBy(tagData.updated_by || "");
      setImageUrl(tagData.image_url || null);
      setStatus(tagData.status || 1);
      setTagImage("");
    }
  }, [tagData, open]);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width === 120 && img.height === 60) {
          setImageUrl(imageUrl);
          setTagImage(file);
        } else {
          alert('Image must be exactly 120px wide and 60px tall.');
          URL.revokeObjectURL(imageUrl);
        }
      };
      img.onerror = () => {
        alert('Failed to load image. Please try again.');
        URL.revokeObjectURL(imageUrl);
      };
    }
  };

  const handleEditSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    
    const reqData = {
      'id': tagData.id ? tagData.id : "",
      'product_tag': productTag ? productTag : "",
      'tag_family': selectedFamily ? selectedFamily : "",
      'category': selectedCategory ? selectedCategory : "",
      'created_by': createdBy ? createdBy : "",
      'updated_by': updatedBy ? updatedBy : "",
      'image_url': imageUrl ? imageUrl : "",
      'status': status ? status : 1,
    };
    
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };
    
    if (tagImage) {
      reqData.image_url = await convertToBase64(tagImage);
    } else {
      reqData.image_url = imageUrl; // Use the object URL if no file is uploaded  
    }
    
    try {
      const resData = await postData("/api/product/acc_tag_master", reqData);
      console.log(resData);
      if (resData["data"]["code"] === "200") {
        setLoading(false);
        alert("Tag updated successfully");
        if (onSave) onSave();
        onClose();
      } else {
        alert("Tag update failed");
        setLoading(false);
      }
    } catch (error) {
      alert("Error updating tag");
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 800,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 3,
        borderRadius: 0,
        border: "2px solid #F4F3F6",
      }}>
        <Typography variant="h6" sx={{ mb: 5, fontWeight: 700, fontFamily: "Inter", fontSize: 17 }}>
          Edit Tag
        </Typography>
        <form onSubmit={handleEditSubmit}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={{ color: "#424956", fontWeight: 700, fontSize: 14 }}>
                Product Tag
              </Typography>
              <TextField
                size="small"
                fullWidth
                sx={{ "& .MuiOutlinedInput-root": { height: "35px", borderRadius: "0px" } }}
                value={productTag}
                onChange={(e) => setProductTag(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={{ color: "#424956", fontWeight: 700, fontSize: 14 }}>
                Tag Category
              </Typography>
              <Select
                fullWidth
                size="small"
                sx={{ height: "35px", borderRadius: "0px" }}
                value={selectedCategory}
                onChange={(event) => setSelectedCategory(event.target.value)}
              >
                {categoryData.map((category) => (
                  <MenuItem key={category.id} value={category.id} sx={{ fontSize: 14 }}>
                    {category.category}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={{ color: "#424956", fontWeight: 700, fontSize: 14 }}>
                Tag Family
              </Typography>
              <Select
                fullWidth
                size="small"
                sx={{ height: "35px", borderRadius: "0px" }}
                value={selectedFamily}
                onChange={(event) => setSelectedFamily(event.target.value)}
              >
                {familyData.map((family) => (
                  <MenuItem key={family.id} value={family.id} sx={{ fontSize: 14 }}>
                    {family.tag_family}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ mt: 0.5, width: 120, height: 60, border: "1px solid #FAFAFB", backgroundColor: "#FAFAFB", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {imageUrl ? (
                  <img src={imageUrl} alt="Uploaded" style={{ width: "100%", height: "100%" }} />
                ) : (
                  <LandscapeIcon sx={{ color: "#BCC1CA" }} />
                )}
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1, width: 120 }}>
                <label style={{ fontSize: "13px", color: "black" }}>Upload Image (120x60px)</label>
                <IconButton component="label" size="small" sx={{ color: "#000" }}>
                  <FileUploadOutlinedIcon />
                  <input type="file" accept="image/*" hidden onChange={handleImageUpload} />
                </IconButton>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <Button
              variant="outlined"
              sx={{ backgroundColor: "#565E6D", border: "1px solid #565E6D", color: "#fff", "&:hover": { backgroundColor: "#546e7a" }, borderRadius: "0px" }}
              type="submit"
              disabled={loading}
            >
              Save Changes
            </Button>
            <Button 
                onClick={onClose} 
                sx={{ ml: 2, backgroundColor: "white", border: "1px solid #565E6D", color: "#565E6D", "&:hover": { backgroundColor: "#546e7a" }, borderRadius: "0px" }}
                variant="outlined" 
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
}
